import type { RewardClaim } from '@/entities/reward-claim'
import type { PlantGardenV2Runtime } from '@/repositories/plant-garden-v2'

export interface RewardClaimDeliveryDependencies {
  plantGarden: Pick<PlantGardenV2Runtime, 'applyRewardClaim'>
  onPlantExperienceGranted?: (completedAt: string) => Promise<void>
}

export async function deliverRewardClaim(
  claim: RewardClaim,
  dependencies: RewardClaimDeliveryDependencies,
): Promise<{ status: 'delivered' | 'already-completed' }> {
  if (claim.status === 'completed') return { status: 'already-completed' }

  if (!claim.plantExperienceGrantedAt) {
    await dependencies.plantGarden.applyRewardClaim(claim.studentId, claim.id)
    await dependencies.onPlantExperienceGranted?.(new Date().toISOString())
  }

  return { status: 'delivered' }
}
